import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { BILLING_REPOSITORY } from '../domain/repositories/billing.repository';
import { BillingRemoteDatasource } from './datasources/remote/billing.remote-datasource';
import { ClientSearchResultMapper } from './mappers/client-search-result.mapper';
import { EstimateItemMapper } from './mappers/estimate-item.mapper';
import { EstimateMapper } from './mappers/estimate.mapper';
import { InvoiceMapper } from './mappers/invoice.mapper';
import { InvoiceRowMapper } from './mappers/invoice-row.mapper';
import { PatientSearchResultMapper } from './mappers/patient-search-result.mapper';
import { PaymentMapper } from './mappers/payment.mapper';
import { BillingRepositoryImpl } from './repositories/billing.repository.impl';

export function provideBillingData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    BillingRemoteDatasource,
    InvoiceMapper,
    InvoiceRowMapper,
    PaymentMapper,
    EstimateMapper,
    EstimateItemMapper,
    ClientSearchResultMapper,
    PatientSearchResultMapper,
    { provide: BILLING_REPOSITORY, useClass: BillingRepositoryImpl },
  ]);
}
